import type ModuleButtonsType from '../components/ModuleButtonsType';
import {
	showAddToCampaignDialog,
	showDocumentSettingsEditDialog,
	showDeleteDialog,
	showDetailsReportingDialog,
	Utils
} from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { showKpisGoalsEditDialog } from 'app/main/submodules/kpis/components/KpisGoalsEditDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';
import { showCompaniesMergeDialog } from './components/CompaniesMergeDialog';
import { showCompaniesOrderNotesEditDialog } from './components/CompaniesOrderNotesEditDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_OPEN_MAPS',
				icon: 'directions',
				action: ({ model }) =>
					Utils.openMaps([model.comp_address, model.comp_city, model.dist_title, model.ctry_title].join(' '))
			},
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'companies'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'companies', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'companies'),
				action: ({ model, t }) => {
					const { comp_title } = model;
					Utils.openLink({
						pathname: '/companies/add',
						state: {
							model: { ...model, comp_title: comp_title + t('COPY'), comp_description: '' }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'companies', note_table_uid: model.comp_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PERSON',
				icon: 'card-account-details-outline',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'people'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'people',
							updateRefresh,
							model: { peop_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: { chro_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: { acti_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: { oppo_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: { cntr_comp_uid: model.comp_uid }
						})
					)
			},
			// {
			// 	name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
			// 	icon: 'basket',
			// 	iconAdd: true,
			// 	hidden: ({ isModuleDisabled, authorizer }) =>
			// 		isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'orders',
			// 				updateRefresh,
			// 				model: { ords_comp_uid: model.comp_uid }
			// 			})
			// 		)
			// },
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: { proj_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: { wore_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: { tick_comp_uid: model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_COMPANIES_MERGE',
				icon: 'call-merge',
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showCompaniesMergeDialog({ compUid: model.comp_uid, updateRefresh }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'companies'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'companies',
							id: model.comp_uid,
							title: model.comp_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'companies'),
				action: () => Utils.openLink({ pathname: '/companies/add' })
			}
		]
	},
	details: {
		headerButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_OPEN_MAPS',
				icon: 'directions',
				action: ({ model }) =>
					Utils.openMaps(
						`${model.comp_address || ''} ${model.comp_city || ''} ${model.dist_title || ''} ${
							model.ctry_title || ''
						}`
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_OPEN_ALLIANZ_TRADE',
				icon: 'open-in-new',
				disabled: ({ model }) => model.comp_vatnumber === null,
				action: ({ model }) =>
					Utils.openLink({
						pathname: `https://online.allianz-trade.com/risk-services/request/company-search?tab=byIdentifier&idValue=${model.comp_vatnumber}&country=IT&idType=TVAIT&type=other`,
						newTab: true,
						external: true
					})
			},
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'companies'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'VIEW_ITEM_BUTTON_COMPANIES_MERGE',
				icon: 'call-merge',
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showCompaniesMergeDialog({ compUid: model.comp_uid, updateRefresh }))
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DOCUMENTS_SETTINGS',
				icon: 'folder-wrench',
				disabled: ({ model, sysSettings }) => !sysSettings[`docs_${model.core_type}_path`],
				hidden: ({ authorizer, sysSettings }) =>
					sysSettings.docs_enabled !== 'true' || authorizer.cannot('update', 'companies'),
				action: ({ model, dispatch, sysSettings, updateRefresh }) =>
					dispatch(
						showDocumentSettingsEditDialog({
							module: 'companies',
							docsFolderPath: `${sysSettings[`docs_${model.core_type}_path`]}\\`,
							itemUid: model.comp_uid,
							folderName: model.comp_foldername,
							updateRefresh
						})
					)
			},
			{
				name: 'DETAILS_HEADER_BUTTON_COMPANIES_ORDERS_NOTES',
				icon: 'card-text-outline',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'companies'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showCompaniesOrderNotesEditDialog({ model, updateRefresh }))
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'companies'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'companies',
							id: model.comp_uid,
							title: model.comp_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'companies'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'people',
				name: 'DETAILS_HEADER_BUTTON_NEW_PERSON',
				icon: 'card-account-details-outline',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'people'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'people',
							updateRefresh,
							model: { peop_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'kpis-goals',
				name: 'BUTTON_KPI_GOAL_NEW',
				icon: 'target-arrow',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('sys_kpis_goals') || authorizer.cannot('create', 'sys_kpis_goals'),
				action: ({ dispatch, updateRefresh, model }) => {
					dispatch(
						showKpisGoalsEditDialog({
							aggregation: { module: 'companies', value: model.comp_uid },
							isAdd: true,
							updateRefresh
						})
					);
				}
			},
			{
				id: 'chronology',
				name: 'DETAILS_HEADER_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: { chro_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'activities',
				name: 'DETAILS_HEADER_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: { acti_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'orders',
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer, model }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: {
								ords_comp_uid: model.comp_uid,
								ords_peop_uid: model.comp_peop_uid,
								ords_user_assigned_uid: model.comp_user_assigned_uid,
								ords_user_assigned_2_uid: model.comp_user_assigned_2_uid
							}
						})
					)
			},
			{
				id: 'commercialcampaigns',
				name: 'DETAILS_HEADER_BUTTON_ADD_TO_COMMERCIALCAMPAIGN',
				icon: 'binoculars',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('commercialcampaigns') || authorizer.cannot('update', 'commercialcampaigns'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showAddToCampaignDialog({
							model,
							updateRefresh,
							module: 'commercialcampaigns',
							table: 'companies'
						})
					)
			},
			{
				id: 'marketingactions',
				name: 'DETAILS_HEADER_BUTTON_ADD_TO_MARKETINGACTION',
				icon: 'bullhorn',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('marketingactions') || authorizer.cannot('update', 'marketingactions'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showAddToCampaignDialog({
							model,
							updateRefresh,
							module: 'marketingactions',
							table: 'companies'
						})
					)
			},
			{
				id: 'dems',
				name: 'DETAILS_HEADER_BUTTON_ADD_TO_DEM',
				icon: 'email-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('dems') || authorizer.cannot('update', 'dems'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showAddToCampaignDialog({ model, updateRefresh, module: 'dems', table: 'companies' }))
			},
			{
				id: 'opportunities',
				name: 'DETAILS_HEADER_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: { oppo_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'contracts',
				name: 'DETAILS_HEADER_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: { cntr_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'projects',
				name: 'DETAILS_HEADER_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: { proj_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'workreports',
				name: 'DETAILS_HEADER_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: { wore_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'tickets',
				name: 'DETAILS_HEADER_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: { tick_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'invoices',
				name: 'DETAILS_HEADER_BUTTON_NEW_INVOICE',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('invoices') || authorizer.cannot('create', 'invoices'),
				action: ({ dispatch, updateRefresh, model }) => {
					dispatch(
						showFastAddDialog({
							module: 'invoices',
							updateRefresh,
							maxDialogWidth: 'lg',
							model: { invc_comp_uid: model.comp_uid }
						})
					);
				}
			},
			{
				id: 'child-companies',
				name: 'DETAILS_HEADER_BUTTON_NEW_CHILD',
				icon: 'domain',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'companies'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'companies',
							updateRefresh,
							model: { comp_parent_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'lead-companies',
				name: 'DETAILS_HEADER_BUTTON_NEW_LEAD_COMPANY',
				icon: 'domain',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'companies'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'companies',
							updateRefresh,
							model: { comp_broker_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'lead-people',
				name: 'DETAILS_HEADER_BUTTON_NEW_LEAD_PERSON',
				icon: 'card-account-details-outline',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'people'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'people',
							updateRefresh,
							model: { peop_broker_comp_uid: model.comp_uid }
						})
					)
			},
			{
				id: 'creditsafe',
				name: 'COMPANIES_CREDITSAFE_BUTTON_DOWNLOAD',
				icon: 'download',
				hidden: ({ authorizer, model }) =>
					authorizer.cannot('update', 'companies_financialstatements_creditsafe') ||
					!model.comp_creditsafe_id,
				action: () => document.dispatchEvent(new Event('onCompaniesCreditsafeReportsDownload'))
			},
			{
				id: 'atoka',
				name: 'COMPANIES_ATOKA_BUTTON_DOWNLOAD',
				icon: 'download',
				hidden: ({ authorizer, model }) =>
					authorizer.cannot('update', 'companies_financialstatements_atoka') || !model.comp_atoka_id,
				action: () => document.dispatchEvent(new Event('onCompaniesAtokaReportsDownload'))
			}
		]
	}
};

export default buttons;
